/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  let nostoSegmentationRun = false;

  // Howdy Customer Tag Discount — PDP pricing engine
  let howdyPdpPricingBound = false;

  function getHowdyConfig() {
    return window.theme && window.theme.howdy ? window.theme.howdy : null;
  }

  function parseJsonScript(container, selector) {
    const element = container.querySelector(selector);
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  const HOWDY_PRODUCT_COLLECTION_CACHE_KEY = 'howdyProductCollectionsByKey';

  function getHowdyCollectionCache() {
    try {
      const raw = window.localStorage.getItem(HOWDY_PRODUCT_COLLECTION_CACHE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function setHowdyCollectionCache(cache) {
    try {
      window.localStorage.setItem(
        HOWDY_PRODUCT_COLLECTION_CACHE_KEY,
        JSON.stringify(cache)
      );
    } catch (error) {
      // Ignore storage failures so pricing never breaks on quota/privacy limits.
    }
  }

  function buildHowdyCollectionCacheKeys(productJson) {
    const keys = [];
    if (!productJson || typeof productJson !== 'object') return keys;

    if (productJson.id != null) {
      keys.push(String(productJson.id));
    }

    if (productJson.handle) {
      keys.push(String(productJson.handle));
    }

    return keys;
  }

  function cacheHowdyProductCollections(productJson, collections) {
    if (!Array.isArray(collections) || !collections.length) return;

    const normalizedCollections = collections
      .map(function(id) { return Number(id); })
      .filter(function(id) { return Number.isFinite(id) && id > 0; });

    if (!normalizedCollections.length) return;

    const cacheKeys = buildHowdyCollectionCacheKeys(productJson);
    if (!cacheKeys.length) return;

    const cache = getHowdyCollectionCache();
    let changed = false;

    cacheKeys.forEach(function(key) {
      const existingValue = cache[key];
      const nextValue = normalizedCollections.slice();
      const sameValue = Array.isArray(existingValue)
        && existingValue.length === nextValue.length
        && existingValue.every(function(id, index) { return id === nextValue[index]; });

      if (!sameValue) {
        cache[key] = nextValue;
        changed = true;
      }
    });

    if (changed) {
      setHowdyCollectionCache(cache);
    }
  }

  function formatMoney(cents) {
    var theme = window.theme || {};
    var settings = theme.settings || {};
    var currencyCodeEnabled = !!settings.currency_code_enable;
    var format;
    if (currencyCodeEnabled && theme.moneyWithCurrencyFormat) {
      format = theme.moneyWithCurrencyFormat;
    } else if (theme.moneyFormat) {
      format = theme.moneyFormat;
    } else {
      format = '${{amount}}';
    }
    if (window.themeVendor && window.themeVendor.themeCurrency && window.themeVendor.themeCurrency.formatMoney) {
      return window.themeVendor.themeCurrency.formatMoney(cents, format);
    }
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function getProductQuantity(productContainer) {
    const quantityInput = productContainer.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function resolveProductContainer(target) {
    if (!(target instanceof Element)) return null;
    if (target.matches('[data-product]')) return target;
    return target.querySelector('[data-product]') || target.closest('[data-product]');
  }

  function normalizeHowdyCollectionGid(collection) {
    if (collection == null) return '';

    if (typeof collection === 'object') {
      collection = collection.id || collection.categoryId || collection.collectionId || collection.value || '';
    }

    const value = String(collection).trim();
    if (!value) return '';
    if (value.indexOf('gid://shopify/Collection/') === 0) return value;

    const numericId = value.match(/\d+/);
    return numericId ? 'gid://shopify/Collection/' + numericId[0] : '';
  }

  function normalizeHowdyCollectionList(collections) {
    if (Array.isArray(collections)) return collections;
    if (collections == null) return [];

    if (typeof collections === 'string') {
      const gidMatches = collections.match(/gid:\/\/shopify\/Collection\/\d+/g);
      if (gidMatches && gidMatches.length) return gidMatches;

      const numericMatches = collections.match(/\d+/g);
      return numericMatches || [];
    }

    return [collections];
  }

  function getHowdyEligibleDiscountPercent(productCollections) {
    const howdyConfig = getHowdyConfig();
    if (
      !howdyConfig ||
      !howdyConfig.customer ||
      !howdyConfig.customer.loggedIn ||
      !Array.isArray(howdyConfig.customer.tags) ||
      !Array.isArray(howdyConfig.orderDiscountSettings)
    ) {
      return 0;
    }

    const customerTags = howdyConfig.customer.tags;
    const discountRules = howdyConfig.orderDiscountSettings;
    const collectionSettings = howdyConfig.collectionDiscountSettings || {};
    const selectedCollectionIds = Array.isArray(collectionSettings.selectedCollectionIds)
      ? collectionSettings.selectedCollectionIds
      : [];
    const productCollectionGids = normalizeHowdyCollectionList(productCollections)
      .map(normalizeHowdyCollectionGid)
      .filter(Boolean);

    let maxDiscountPercent = 0;

    discountRules.forEach(function(discountRule) {
      if (!discountRule || !customerTags.includes(discountRule.tagName)) return;

      const targetCollections = Array.isArray(discountRule.targetCollections) ? discountRule.targetCollections : [];
      let appliesToProduct = false;

      if (targetCollections.length > 0) {
        appliesToProduct = targetCollections.some(function(tc) { return productCollectionGids.includes(tc); });
      } else if (selectedCollectionIds.length > 0) {
        appliesToProduct = selectedCollectionIds.some(function(sc) { return productCollectionGids.includes(sc); });
      } else {
        appliesToProduct = true;
      }

      if (!appliesToProduct) return;

      const discountPercent = parseFloat(discountRule.discountPercent) || 0;
      if (discountPercent > maxDiscountPercent) {
        maxDiscountPercent = discountPercent;
      }
    });

    return maxDiscountPercent;
  }

  function getSavingsText(basePrice, finalPrice) {
    const savings = Math.max(basePrice - finalPrice, 0);
    const howdyDisplayType = window.theme && window.theme.settings && window.theme.settings.savingBadgeType
      ? window.theme.settings.savingBadgeType
      : 'money';
    if (howdyDisplayType === 'percentage' && basePrice > 0) {
      return Math.round((savings / basePrice) * 100) + '%';
    }
    return formatMoney(savings);
  }

  function updatePricePresentation(productContainer, priceState) {
    const priceWrappers = productContainer.querySelectorAll('[data-price-wrapper]');
    const productQuantity = getProductQuantity(productContainer);
    const showComparePrice = Boolean(priceState.comparePrice && priceState.comparePrice > priceState.price);
    const comparePriceText = priceState.comparePrice ? formatMoney(priceState.comparePrice) : '';

    priceWrappers.forEach(function(wrapper) {
      const comparePriceElement = wrapper.querySelector('[data-compare-price]');
      const productPriceElement = wrapper.querySelector('[data-product-price]');
      const displayPrice = wrapper.hasAttribute('data-atc-button') ? priceState.price * productQuantity : priceState.price;
      const priceText = displayPrice === 0 ? window.theme.strings.free : formatMoney(displayPrice);

      if (!productPriceElement) return;
      productPriceElement.innerHTML = priceText;
      productPriceElement.classList.toggle('product__price--sale', showComparePrice);
      if (!comparePriceElement) return;
      comparePriceElement.innerHTML = comparePriceText;
      comparePriceElement.classList.toggle('hidden', !showComparePrice);
    });

    const priceOffWrappers = productContainer.querySelectorAll('[data-price-off]');
    if (!priceOffWrappers.length) return;

    priceOffWrappers.forEach(function(priceOffWrap) {
      const priceOffType = priceOffWrap.querySelector('[data-price-off-type]');
      const priceOffAmount = priceOffWrap.querySelector('[data-price-off-amount]');
      if (!priceOffAmount) return;

      if (priceState.showSavings) {
        if (priceOffType) {
          priceOffType.textContent = priceState.typeLabel || window.theme.strings.sale_badge_text;
        }
        priceOffAmount.textContent = getSavingsText(priceState.comparePrice, priceState.price);
        priceOffWrap.classList.remove('hidden');
        return;
      }

      if (priceOffType) priceOffType.textContent = window.theme.strings.sale_badge_text;
      priceOffAmount.textContent = '';
      priceOffWrap.classList.add('hidden');
    });
  }

  function buildNativePriceState(variant) {
    const comparePrice = variant && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
    return {
      comparePrice: comparePrice,
      price: variant.price,
      showSavings: Boolean(comparePrice),
      typeLabel: window.theme.strings.sale_badge_text
    };
  }

  function buildHowdyPriceState(variant, discountPercent) {
    const discountedPrice = Math.round(variant.price * ((100 - discountPercent) / 100));
    // Preserve existing compare-at if present and higher than price
    const comparePrice = (variant.compare_at_price && variant.compare_at_price > variant.price)
      ? variant.compare_at_price
      : variant.price;
    return {
      comparePrice: comparePrice,
      price: discountedPrice,
      showSavings: comparePrice > discountedPrice,
      typeLabel: window.theme.strings.sale_badge_text
    };
  }

  function applyHowdyPdpPricing(productContainer, variantOverride) {
    if (!productContainer) return;

    const productContext = parseJsonScript(productContainer, '[data-howdy-product-context]');
    const productJson = parseJsonScript(productContainer, '[data-product-json]');

    if (!productContext || !productJson || !Array.isArray(productJson.variants)) return;

    cacheHowdyProductCollections(productJson, productContext.collections);

    let activeVariant = variantOverride;

    if (!activeVariant) {
      const variantIdInput = productContainer.querySelector('input[name="id"]');
      const selectedVariantId = variantIdInput ? Number(variantIdInput.value) : null;
      activeVariant = productJson.variants.find(function(v) { return v.id === selectedVariantId; });
    }

    if (!activeVariant) {
      activeVariant = productJson.variants.find(function(v) { return v.available; });
    }

    if (!activeVariant) return;

    const discountPercent = getHowdyEligibleDiscountPercent(productContext.collections);

    if (discountPercent <= 0) {
      return;
    }

    const priceState = buildHowdyPriceState(activeVariant, discountPercent);
    updatePricePresentation(productContainer, priceState);
  }

  function scheduleHowdyPdpPricing(productContainer, variantOverride) {
    if (!productContainer) return;
    window.requestAnimationFrame(function() {
      applyHowdyPdpPricing(productContainer, variantOverride);
    });
  }

  function applyHowdyPdpPricingInScope(scope) {
    if (!scope) return;
    const productContainers = [];
    if (scope instanceof Element && scope.matches('[data-product]')) {
      productContainers.push(scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-product]').forEach(function(c) { productContainers.push(c); });
    }
    productContainers.forEach(function(c) { scheduleHowdyPdpPricing(c); });
  }

  function bindHowdyPdpPricingEvents() {
    if (howdyPdpPricingBound) return;
    howdyPdpPricingBound = true;

    document.addEventListener('theme:variant:change', function(event) {
      const productContainer = resolveProductContainer(event.target);
      const variant = event.detail && event.detail.variant ? event.detail.variant : null;
      if (!productContainer || !variant) return;
      scheduleHowdyPdpPricing(productContainer, variant);
    });

    document.addEventListener('shopify:section:load', function(event) {
      applyHowdyPdpPricingInScope(event.target);
    });
  }

  function initializeHowdyPdpPricing() {
    bindHowdyPdpPricingEvents();
    applyHowdyPdpPricingInScope(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHowdyPdpPricing);
  } else {
    initializeHowdyPdpPricing();
  }

  // Resolve a product's collections by id/handle when the caller can't provide them
  // directly. The PDP pricing engine populates this cache on every product visit,
  // so search/recommendation surfaces (e.g. Nosto) that don't expose collection ids
  // can still match collection-scoped Howdy rules for previously-seen products.
  function lookupCachedProductCollections(productId, handle) {
    const cache = getHowdyCollectionCache();
    if (productId != null && Array.isArray(cache[String(productId)])) {
      return cache[String(productId)];
    }
    if (handle && Array.isArray(cache[String(handle)])) {
      return cache[String(handle)];
    }
    return [];
  }

  function getHowdyEligibleDiscountPercentForProduct(options) {
    const opts = options || {};
    const direct = normalizeHowdyCollectionList(opts.collectionIds);
    const collections = direct.length
      ? direct
      : lookupCachedProductCollections(opts.productId, opts.handle);
    return getHowdyEligibleDiscountPercent(collections);
  }

  // Expose eligibility helpers so external renderers (e.g. Nosto templates) can reuse
  // the same customer-tag discount logic without duplicating it.
  window.theme = window.theme || {};
  window.theme.howdy = window.theme.howdy || {};
  window.theme.howdy.getEligibleDiscountPercent = getHowdyEligibleDiscountPercent;
  window.theme.howdy.getEligibleDiscountPercentForProduct = getHowdyEligibleDiscountPercentForProduct;

  // Nosto Customer Segmentation
  function addCustomerToNostoSegment() {
    if (nostoSegmentationRun) return; // Prevent double run
    nostoSegmentationRun = true;

    const customerLoggedIn =
      document.querySelector(".customer-logged-in") !== null;
      

    if (!customerLoggedIn) {
      return;
    }

    // Wait for Nosto to be available
    function waitForNosto() {
      if (typeof nostojs === "function") {
        nostojs(function (api) {
          api.addSegmentCodeToVisit("logged-in");
        });
      } else {
        setTimeout(waitForNosto, 100);
      }
    }

    waitForNosto();
  }

  // Run on page load
  document.addEventListener("DOMContentLoaded", function () {
    addCustomerToNostoSegment();
  });

  // run immediately in case DOM is already loaded
  if (document.readyState === "loading") {
    // Document is still loading, wait for DOMContentLoaded
  } else {
    // Document is already loaded, run immediately
    addCustomerToNostoSegment();
  }

  if (window.location.pathname.includes("/products/")) {
    document.addEventListener("DOMContentLoaded", function () {
      const optionContainers = document.querySelectorAll(".radio__buttons");

      optionContainers.forEach((container) => {
        container.addEventListener("change", function (event) {
          const input = event.target;
          if (
            input.matches('input[type="radio"][data-single-option-selector]')
          ) {
            const selectedValue = input.value;
            const legend = container
              .closest("fieldset")
              .querySelector(".selected-option-value");
            if (legend) {
              legend.textContent = selectedValue;
            }
          }
        });
      });
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
